import { CheckIsGlobalTabType } from './interfaces';
import { ChatTabs } from '../../../../interfaces/channel';

export const checkIsGlobalTab: CheckIsGlobalTabType = (tab) =>
  tab === ChatTabs.Global;
